/* eslint-disable react/jsx-no-useless-fragment */
import React, { useEffect, useRef, useCallback } from 'react';
// import { useNavigate } from 'react-router-dom';
import { useStateContext } from '../contexts/ContextProvider';

let INACTIVITY_TIMEOUT = 15 * 60 * 1000; // 15 minutes in milliseconds

const AutoLogoutHandler = ({ children }) => {
  // const navigate = useNavigate();
  const timeoutRef = useRef(null);
  // const timeoutTick = useRef(null);
  const {
    // elapsed,
    setElapsed,
    idleLogout,
  } = useStateContext();

  const logoutUser = useCallback(() => {
    // Implement your actual logout logic here
    // localStorage.removeItem('organization');
    localStorage.removeItem('user');
    // setLoggedIn(false);
    window.location.assign('/login');
    // window.close();
    // navigate('/'); // Redirect to login page
  }, []);

  const resetTimer = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(logoutUser, INACTIVITY_TIMEOUT);
    // console.log('Setting Elapsed to ', INACTIVITY_TIMEOUT, new Date());
    setElapsed(INACTIVITY_TIMEOUT);
  }, [logoutUser]);

  useEffect(() => {
    const activityEvents = ['mousemove', 'keydown', 'click', 'scroll'];

    activityEvents.forEach((event) => {
      window.addEventListener(event, resetTimer);
    });

    resetTimer(); // Start the timer when the component mounts

    return () => {
      // Clean up event listeners and timer on unmount
      activityEvents.forEach((event) => {
        window.removeEventListener(event, resetTimer);
      });
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [resetTimer]);
  useEffect(() => {
    INACTIVITY_TIMEOUT = Number(idleLogout) * 60 * 1000;
    // console.log('Setting IdleTimeout  to ', INACTIVITY_TIMEOUT, new Date());
  }, [idleLogout]);
  /*
  useEffect(() => {
    timeoutTick.current = setTimeout(() => { setElapsed(elapsed - 1); }, 1000);
    return () => {
      // Clean up event listeners and timer on unmount
      if (timeoutTick.current) {
        clearTimeout(timeoutTick.current);
      }
    };
  });
  */
  return <>{children}</>;
};

export default AutoLogoutHandler;
